<template>
  <div class="info" v-if="showInfo">
    <div class="about">
      <h1>
        Click to mark hotkeys as "Learning" or "Learned". <br/>
        Your progress is saved locally. <br/>
      </h1>
      <a href="javascript:void(0)" @click="$emit('toggle-info')">
        <span v-if="showInfo">Hide the help section</span>
      </a>
    </div>
    <div class="legend">
      <hotkey-item :item="{ name: 'Learning'}" :stage="1"/>
      <hotkey-item :item="{ name: 'Learned'}" :stage="2"/>
      <hotkey-item :item="{ name: 'Most useful hotkeys', featured: true}" :stage="0"/>
    </div>
  </div>
</template>

<script>
  import HotkeyItem from "./HotkeyItem";

  export default {
    name: "HeaderHelp",
    components: {HotkeyItem},
    props: ['showInfo']
  }
</script>

<style lang="scss">
  .info {
    display: flex;
    justify-content: space-between;

    padding: 12px;

    border: 1px solid hsl(204, 30%, 85%);
    border-left: none;
    border-right: none;

    .about {
      h1 {
        font-size: 20px;
        font-weight: normal;
        color: hsl(204, 50%, 30%);
      }
      a {
        border-bottom: 1px dashed hsl(204, 50%, 40%);
        font-size: 14px;
      }
    }

    .legend {
      width: 250px;
    }
  }
</style>